import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import LeftArrow from "../../assets/Left 1.svg";
import "./TopNav.css";
import React from "react";
import { Box } from "@mui/material";

const CustomAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "transparent",
  height: "12vh",
  boxShadow: "none",
}));

interface TopNavProps {
  showArrow?: boolean; // Make props optional if not always needed
  backRoute?: string;
  backClick?: () => void;
}

const TopNav: React.FC<TopNavProps> = ({
  showArrow = false,
  backRoute,
  backClick,
}) => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    if (backClick) {
      backClick();
    } else {
      if (backRoute) {
        navigate(backRoute);
      } else {
        navigate(-1);
      }
    }
  };
  return (
    <CustomAppBar
      position="static"
      sx={{
        alignItems: "start",
        display: "flex",
        justifyContent: "center",
        px: { xs: 2, sm: 10 },
        py: 4,
        paddingTop: "40px",
      }}
    >
      {showArrow && (
        // <IconButton
        //   edge="start"
        //   color="inherit"
        //   aria-label="menu"
        //   onClick={() => navigate(-1)}
        // >
        //   <ArrowBackIcon />
        // </IconButton>
        <img src={LeftArrow} onClick={handleBackClick} />
      )}
    </CustomAppBar>
  );
};

export default TopNav;
